import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import IBKRImport from "./pages/IBKRImport";
import RevolutImport from "./pages/RevolutImport";
import DBOrder from "./pages/DBOrder";
import SMASurveillance from "./pages/SMASurveillance";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/ibkr-import" element={<IBKRImport />} />
          <Route path="/revolut-import" element={<RevolutImport />} />
          <Route path="/db-order" element={<DBOrder />} />
          <Route path="/sma-surveillance" element={<SMASurveillance />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
